"use client"

import { ClientOnly } from "@tanstack/react-router"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import * as React from "react"

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  return (
    <ClientOnly>
      <NextThemesProvider {...props}>{children}</NextThemesProvider>
    </ClientOnly>
  )
}
